import React, { useEffect, useState } from 'react';
import { filter, Subject, takeUntil } from 'rxjs';

import useStyles from 'isomorphic-style-loader/useStyles';
import {
	Container, DataService, XpSourceName, i18n,
} from '../../../../../symphony';

import { Widget } from '../../Widget/Widget';
import { SlLEContext } from '../../../global-constants';
import { SlDataService } from '../../../services/sl-data.service';

import {
	ActionType,
	IMaterialProps,
	IWidgetData,
	RequestType,
} from '../../../global-interface';
import { SlActions } from '../../../services/ActionsService/sl-actions';

import s from './CodeRepo.scss';

export function CodeRepo({ materialInfo }: IMaterialProps): JSX.Element {
	useStyles(s);
	const {
		header: {
			title, description, typeId, id, uiConfigurations, materialRelationId,
		},
		status,
		options,
	} = materialInfo;
	const { xpSourcesList$ } = Container.take('global', DataService);

	const [isCurrentCR, setIsCurrentCR] = useState<boolean>(false);

	const xp = xpSourcesList$.value?.xpSources.find(
		(item) => item.sourceName === XpSourceName.CodeRepoCommit,
	)?.xp;

	useEffect(() => {
		const { currentItems$ } = Container.take(SlLEContext, SlDataService);

		const unsubscriber = new Subject<void>();

		currentItems$
			.pipe(
				takeUntil(unsubscriber),
				filter((i) => !!i),
			)
			.subscribe((items) => setIsCurrentCR(
				items.some(({ materialId }) => materialId === materialRelationId),
			));

		return () => {
			unsubscriber.next();
			unsubscriber.complete();
		};
	}, []);

	const onPracticeClickHandler = () => {
		const { actions$ } = Container.take(SlLEContext, SlActions);
		actions$.next({
			type: ActionType.onCRPracticeClick,
			requestType: RequestType.Parallel,
			data: {
				materialInfo,
			},
		});
	};

	const widgetData: IWidgetData = {
		status,
		title,
		description,
		xp,
		type: typeId,
		button: {
			title: i18n.t('web-le.material-type-practice'),
			onClick: onPracticeClickHandler,
		},
		isCurrent: isCurrentCR,
		iconUrl: uiConfigurations?.iconUrl,
	};

	return (
		<div
			sl-test-data="cmpCodeRepo"
			className="le-code-repo"
			le-data-id={materialRelationId}
		>
			<Widget
				parentType={options.parentType}
				widget={widgetData}
				onClick={onPracticeClickHandler}
				id={id}
			/>
		</div>
	);
}
